/// <reference path="WebService.ts" />

interface WebService
{
    getPayMethodsFromSessionID( sessionID:string, target:any, completion:any ) : void ;
    closeSession( sessionID:string, countedValues:any, target:any, completion:any ) : void ;
    changeCashDeskSessionDate( sessionID:string, beginDate:string, endDate:string, completion:any ) : void ;
}

WebService.prototype.getPayMethodsFromSessionID = function(sessionID:string, target:any, completion:any) : void
{
    const url = MIOURL.urlWithString(this.apiURL + "/entity/" + this.scheme + "/CashDeskSession/" + sessionID + "/payment-method-counted-summary");
    let urlRequest = new MWSJSONRequest();
    urlRequest.initWithURL(url, null, "GET");
    urlRequest.execute(this, function(code, json) {            
        completion.call(target, code, json);
    });
}

WebService.prototype.closeSession = function(sessionID:string, countedValues:any, target:any, completion:any) : void
{        
    const url = MIOURL.urlWithString(this.apiURL + "/entity/" + this.scheme + "/CashDeskSession/" + sessionID + "/adjust");        
    let body = {
        "UserName": (MUIWebApplication.sharedInstance().delegate as AppDelegate).selectedUser.name,
        "Values": countedValues
    }
    let urlRequest = new MWSJSONRequest();        
    urlRequest.initWithURL(url, body, "POST");
    urlRequest.execute(this, function(code:number, json:any) {
        completion.call(target, code, json);
    });
}

WebService.prototype.changeCashDeskSessionDate = function(sessionID:string, beginDate:string, endDate:string, completion:any ) : void
{
    const url_str = this.apiURL + "/entity/" + this.scheme + "/CashDeskSession/" + sessionID + "/change-date"
    let body = {
        "UserName": (MUIWebApplication.sharedInstance().delegate as AppDelegate).selectedUser.name,
        "SessionBeginDate": beginDate,
        "SessionEndDate": endDate
    }
    
    let r = new DLRequest ( url_str, body, "POST" );
    r.execute( (json:any, error:any) => {
        if (error) {
            AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR","ERROR"), error);
            return;
        }

        if (completion) completion();
    } );
}